import { useState } from 'react';
import { Box, Divider } from '@mui/material';
import {
    Button,
    DeleteButton,
    useDataProvider,
    useNotify,
    useRecordContext,
    useRefresh,
} from 'react-admin';
import { Link } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SyncIcon from '@mui/icons-material/Sync';

import type { CrmDataProvider } from '@/providers/types';

export const HelpDocumentAside = () => {
    const record = useRecordContext();
    const notify = useNotify();
    const refresh = useRefresh();
    const dataProvider = useDataProvider<CrmDataProvider>();
    const [reindexing, setReindexing] = useState(false);

    const handleReindex = async () => {
        if (!record?.id) return;
        setReindexing(true);
        try {
            await dataProvider.reindexHelpDocument(Number(record.id));
            notify('Document reindexed', { type: 'info' });
            refresh();
        } catch (err) {
            notify(err instanceof Error ? err.message : 'Reindex failed', {
                type: 'warning',
            });
        } finally {
            setReindexing(false);
        }
    };

    return (
        <Box ml={4} width={250} minWidth={250}>
            <Box my={2}>
                <Button
                    component={Link}
                    to="/settings/help-knowledge"
                    label="Back"
                >
                    <ArrowBackIcon />
                </Button>
            </Box>
            <Divider />
            {record ? (
                <Box my={2}>
                    <Button
                        label={reindexing ? 'Reindexing…' : 'Reindex embeddings'}
                        onClick={handleReindex}
                        disabled={reindexing}
                    >
                        <SyncIcon />
                    </Button>
                    <br />
                    <DeleteButton
                        mutationMode="pessimistic"
                        redirect="/settings/help-knowledge"
                    />
                </Box>
            ) : null}
        </Box>
    );
};
